<template>
    <a11y-dialog
            @dialog-ref="assignDialogRef"
            app-root="#c-whats-on-by-map-app"
            close-button-label="Close"
            dialog-root="#modal-root"
            id="app-dialog"
            :class-names="{document: 'c-dialog-document'}"
    >
        <div class="c-modal__wrap" v-html="content"></div>

        <template v-slot:title>
            <span class="u-hidden-visually" v-html="title"></span>
        </template>

        <template class="c-btn c-btn--ghost" v-slot:closeButtonContent>
            <span class="c-close">Close</span>
        </template>

    </a11y-dialog>
</template>

<script>
    import {EventBus} from "../event-bus"
    import {A11yDialog} from "vue-a11y-dialog"
    import axios from 'axios'
    import {errorMessage} from "../error-message";

    export default {
        name: "Modal",
        components: {
            "a11y-dialog": A11yDialog
        },
        data() {
            return {
                dialog: null,
                content: '',
                title: '',
                contentCache: {}
            }
        },
        mounted() {
            EventBus.$on('open-modal', this.updateContent)
            EventBus.$on('open-modal-with-error', this.updateContentWithError)
        },
        methods: {
            assignDialogRef(dialog) {
                this.dialog = dialog;
                this.dialog.on('show', (dialogEl, event) => {
                    document.body.classList.add('modal-open')

                    // add a click event listener when the dialog is displayed
                    document.addEventListener('click', this.clickOutSideCloseModal, true)
                    this.$parent.isLoading = false
                });

                this.dialog.on('hide', (dialogEl, event) =>{
                    document.body.classList.remove('modal-open')

                    // remove the click event listener when the dialog is removed in order for the dialog to keep
                    // showing when loading the same modal due to the click handler always being present if
                    // left to persist
                    document.removeEventListener('click', this.clickOutSideCloseModal, true)
                    this.isOpen = false
                    this.$parent.isLoading = false
                });
            },
            clickOutSideCloseModal(event) {
                if ((event.target.matches('.c-close') || !event.target.closest('.c-dialog-document'))) {
                    this.dialog.hide()
                }
            },
            updateContentWithError() {
                this.title = 'Error'
                this.content = errorMessage
                this.$parent.isLoading = false
                this.openDialog()
            },
            updateContent(location) {
                if (this.contentCache.hasOwnProperty(location)) {
                    this.content = this.contentCache[location]
                    this.openDialog()
                } else {
                    this.fetchContent(location)
                }
            },
            fetchContent(location) {
                axios.get(window.ajax.url, {
                    params: {
                        action: 'basethemeLocationVenuesModalContent',
                        location: location
                    }
                }).then(response => {
                    const data = response.data
                    this.title = 'Events at this location'
                    this.content = data.modalContent
                    this.contentCache[location] = this.content
                    this.$parent.isLoading = false
                    this.openDialog()
                }).catch(error => {
                        this.updateContentWithError()
                    })
            },
            openDialog() {
                if (this.dialog) {
                    this.dialog.show()
                }
            },
        }

    }
</script>

<style scoped>

</style>
